import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Legal.scss';

interface ILegalProps {
  context?: IContent;
}

const Legal = ({ context }: ILegalProps) => {
  return (
    <section className="legal-container">
      {context.footer_legal.map((el, index) => {
        return  <p key={index} dangerouslySetInnerHTML={{ __html:el }}/> ;
      })}
    </section>
  );
};

export default withContent(Legal);
